export default __webpack_public_path__ + "media/images/react_icons/map-abda16913128ff242e97af2c61350c1f.svg";